import { render, staticRenderFns } from "./QuestionItemPreview.vue?vue&type=template&id=4da8e738&scoped=true&lang=pug"
import script from "./QuestionItemPreview.vue?vue&type=script&lang=js"
export * from "./QuestionItemPreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionItemPreview.vue?vue&type=style&index=0&id=4da8e738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da8e738",
  null
  
)

export default component.exports